/**
 * @author Akshay Kumar Singh
 * @file Helper Util
 * @flow
 */

 /**
 * @description This is used to sort the array of object.
 * @param arrObj Array of object.
 * @param key sort bases of this key
 * @param order Order of sort (By default assending sort)
 */
export const sortArrObj = (arrObj, key, order = 'asc') => {
  return arrObj.sort(compareValues(key, order));
}

/**
 * @description This is used to compare two values.
 * @param key key to compare
 * @param order Order of sort (By default assending sort)
 */
const compareValues = (key, order = 'asc') => {
  return (a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }

    const varA = (typeof a[key] === 'string')
      ? a[key].toUpperCase() : a[key];
    const varB = (typeof b[key] === 'string')
      ? b[key].toUpperCase() : b[key];

    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return (
      (order === 'desc') ? (comparison * -1) : comparison
    );
  };
}
